import { create } from "zustand";

interface UiState {
	/** Currently expanded element ID in the force list */
	expandedElementId: string | null;
	/** Whether the validation panel is open */
	showValidation: boolean;
	/** Whether the element browser sidebar is showing weapon/equipment picker */
	activePickerFor: {
		elementId: string;
		modelId: string;
		pickerType: "weapon" | "equipment";
	} | null;

	/** Whether the mobile sidebar drawer is open */
	isSidebarOpen: boolean;
	/** Whether the mobile header overflow menu is open */
	isOverflowMenuOpen: boolean;

	// Actions
	setExpandedElement: (id: string | null) => void;
	toggleExpandedElement: (id: string) => void;
	toggleValidation: () => void;
	openPicker: (elementId: string, modelId: string, pickerType: "weapon" | "equipment") => void;
	closePicker: () => void;
	openSidebar: () => void;
	closeSidebar: () => void;
	toggleSidebar: () => void;
	setOverflowMenuOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()((set) => ({
	expandedElementId: null,
	showValidation: false,
	activePickerFor: null,
	isSidebarOpen: false,
	isOverflowMenuOpen: false,

	setExpandedElement: (id) => set({ expandedElementId: id }),

	toggleExpandedElement: (id) =>
		set((state) => ({
			expandedElementId: state.expandedElementId === id ? null : id,
		})),

	toggleValidation: () => set((state) => ({ showValidation: !state.showValidation })),

	openPicker: (elementId, modelId, pickerType) =>
		set({ activePickerFor: { elementId, modelId, pickerType } }),

	closePicker: () => set({ activePickerFor: null }),

	openSidebar: () => set({ isSidebarOpen: true }),
	closeSidebar: () => set({ isSidebarOpen: false }),
	toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
	setOverflowMenuOpen: (open) => set({ isOverflowMenuOpen: open }),
}));
